import { Sprite, Text, TextStyle } from "pixi.js";
import { ButtonWithScaleAnimation } from "../../../common/components/ButtonWithScaleAnimation";
import { GameFont } from "../../../common/GameFont";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { LockedContainer } from "./LockedContainer";
import { MyBuildingsResourcePackage } from "../resources/MyBuildingsResourcePackage";

export class ListInButton extends ButtonWithScaleAnimation {
    private static readonly BUTTON_TEXT = "LIST IN";

    private readonly marketPlaceButtonText: Text;
    private readonly marketplaceIcon: Sprite;
    private readonly locked: LockedContainer;

    public constructor(commonResources: CommonResourcesPackage, myBuildingsResources: MyBuildingsResourcePackage, openAtRank: number) {
        super(commonResources.assets_common_ui_button_green_blue_png);
        this.defaultView.width = 262;
        this.defaultView.height = 127;
        this.marketPlaceButtonText = new Text(ListInButton.BUTTON_TEXT, new ListInButtonTextStyle());
        this.marketPlaceButtonText.position.set(25, 34);
        this.addChild(this.marketPlaceButtonText);
        this.marketplaceIcon = new Sprite(commonResources.assets_common_ui_vector_png);
        this.marketplaceIcon.width = 66;
        this.marketplaceIcon.height = 60;
        this.marketplaceIcon.position.set(this.marketPlaceButtonText.position.x + this.marketPlaceButtonText.width + 20, this.marketPlaceButtonText.position.y);
        this.addChild(this.marketplaceIcon);

        this.locked = new LockedContainer(myBuildingsResources, openAtRank);
        this.locked.scale.set(1.1, 1.19);
        this.locked.position.set(120, 46.5);
        this.addChild(this.locked);
        this.setLocked(true);
    }

    public showDefaultStyle(): void {
        this.defaultView.width = 262;
        this.defaultView.height = 127;

        this.marketPlaceButtonText.position.set(25, 34);
        this.marketplaceIcon.position.set(this.marketPlaceButtonText.position.x + this.marketPlaceButtonText.width + 20, this.marketPlaceButtonText.position.y);

        this.locked.scale.set(1.1, 1.19);
        this.locked.position.set(120, 46.5);
    }

    public showUpgradeStyle(): void {
        this.defaultView.width = 465;
        this.defaultView.height = 130;

        this.marketPlaceButtonText.position.set(124, 16);
        this.marketplaceIcon.position.set(this.marketPlaceButtonText.position.x + this.marketPlaceButtonText.width + 20, this.marketPlaceButtonText.position.y);

        this.locked.scale.set(1, 1.1);
        this.locked.position.set(260, 42.5);
    }

    public setLocked(value: boolean): void {
        this.locked.visible = value;
        this.eventMode = value ? "none" : "static";
    }
}

class ListInButtonTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 66,
            dropShadow: true,
            dropShadowColor: "#0d0606",
            dropShadowAlpha: 0.3,
            dropShadowAngle: 0.82859,
            dropShadowBlur: 5
        }));
    }
}
